import React, { useState } from "react";
import ShortAnswer from "./Charts/ShortAnswer";
import PieChart from "./Charts/PieChart";
import HorizontalBarChart from "./Charts/BarChart";
import DocumentResponce from "./Charts/DocumentResponce";
import DateResponce from "./Charts/DateResponce";
import TimeAndDate from "./Charts/TimeAndDate";
import "../../../Styles/Form/Analytics.css";

const AnalyticsView = () => {
  // const answer = [
  //   {
  //     question:
  //       "Lorems Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     answer: [
  //       "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //       "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //       "lorem Ipsum has been the industry's standard dummy text ever since the 1500",
  //     ],
  //     type: "Short Answer",
  //     ResponseCount: 3,
  //   },
  //   {
  //     question:
  //       "Lorems Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     answer: [
  //       "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //       "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //       "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //       "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //       "lorem Ipsum has been the industry's standard dummy text ever since the 1500",
  //     ],
  //     type: "Short Answer",
  //     ResponseCount: 5,
  //   },
  //   {
  //     question:
  //       "Lorems Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     type: "Multiple Choice",
  //     ResponseCount: 15,
  //     options: [
  //       "Hello world",
  //       "World hello",
  //       "World world",
  //       "Hello worlds",
  //       "Welcome world",
  //       "Welcomess worlds",
  //       "Welcomess worlds2",
  //     ],
  //     answer: [3, 2, 4, 6, 8, 5, 8],
  //   },
  //   {
  //     question:
  //       "Lorems Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     type: "Checkbox",
  //     ResponseCount: 15,
  //     options: [
  //       "Hello world",
  //       "World hello",
  //       "World world",
  //       "Hello worlds",
  //       "Welcome world",
  //     ],
  //     answer: [3, 2, 4, 6, 8],
  //   },
  //   {
  //     question: "Lorems Ipsum has been the industry's standard dummy text",
  //     type: "Phone",
  //     ResponseCount: 8,
  //     answer: [
  //       "+91 3695845698",
  //       "+91 3695845698",
  //       "+91 3695845698",
  //       "+91 3695845698",
  //       "+91 3695845698",
  //       "+91 3695845698",
  //       "+91 3695845698",
  //       "+91 3695845698",
  //     ],
  //   },
  //   {
  //     question:
  //       "Lorems Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     type: "Document",
  //     ResponseCount: 5,
  //     answer: [
  //       { filename: "HannahBusing_Resume.pdf", fileSize: "1024 kb" },
  //       { filename: "HannahBusing_Resume.pdf", fileSize: "1024 kb" },
  //       { filename: "HannahBusing_Resume.pdf", fileSize: "1024 kb" },
  //       { filename: "HannahBusing_Resume.pdf", fileSize: "1024 kb" },
  //       { filename: "HannahBusing_Resume.pdf", fileSize: "1024 kb" },
  //     ],
  //   },
  //   {
  //     question:
  //       "Lorems Ipsum has been the  standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     type: "Date",
  //     ResponseCount: 10,
  //     answer: [
  //       { date: "10/Apr/2024" },
  //       { date: "11/Apr/2023" },
  //       { date: "07/Apr/2022" },
  //     ],
  //   },
  //   {
  //     question:
  //       "Lorems Ipsum has been the industry's standard dummy text ever since the 1500s NameLorem Ipsum has been the industry's standard dummy text ever since the 1500s Name",
  //     type: "TimeAndDate",
  //     ResponseCount: 10,
  //     answer: [
  //       { date: "10 Apr 2024", time: "06:40 PM" },
  //       { date: "11 Apr 2023", time: "06:40 PM" },
  //       { date: "07 Apr 2022", time: "06:40 PM" },
  //     ],
  //   },
  // ];
  // const [answerArray] = useState(answer);

  const scoreDetails = [
    {
      email: "SSss@gmail.com",
      score: 20,
      scoreReleased: true,
    },
    {
      email: "SSss@gmail.com",
      score: 40,
      scoreReleased: false,
    },
    {
      email: "SSss@gmail.com",
      score: 60,
      scoreReleased: true,
    },
    {
      email: "SSss@gmail.com",
      score: 80,
      scoreReleased: true,
    },
    {
      email: "SSss@gmail.com",
      score: 100,
      scoreReleased: true,
    },
  ];
  return (
    <div className="QuestionView">
      <div className="responce_question_container">
        <div className="score-release-score-top-container">
          <p>SCORE</p>
          <button>Release score</button>
        </div>
        <div className="react-table-score-release">
          <table>
            <thead>
              <tr>
                <th>Email </th>
                <th>Score /{}</th>
                <th>Score released </th>
              </tr>
            </thead>
            <tbody>
              {scoreDetails.map((answer, i) => (
                <tr key={i}>
                  <td>{answer.email}</td>
                  <td>{answer.score}</td>
                  <td>{answer.scoreReleased ? "Released" : "Not released"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* {answerArray.map((answer, i) => (
        <div className="responce_question_container" key={i}>
          <>
            <div className="question_container" key={i}>
              {i + 1}.
              <div className="question">
                <p>{answer.question}</p>
                <p className="responces_count">
                  {answer.ResponseCount} Response
                </p>
              </div>
            </div>
            {renderchart(answer)}
          </>
        </div>
      ))} */}
    </div>
  );
};

const renderchart = (answer) => {
  switch (answer.type) {
    case "Short Answer":
      return <ShortAnswer answer={answer} />;
    case "Multiple Choice":
      return <PieChart answer={answer} />;
    case "Checkbox":
      return <HorizontalBarChart answer={answer} />;
    case "Phone":
      return <ShortAnswer answer={answer} />;
    case "Document":
      return <DocumentResponce answer={answer} />;
    case "Date":
      return <DateResponce answer={answer} />;
    case "TimeAndDate":
      return <TimeAndDate answer={answer} />;
    default:
      return null;
  }
};
export default AnalyticsView;

// LikertScaleChart
